export default __webpack_public_path__ + "static/media/progress-bar.f2f39118.svg";